import coordinatesT from '../utils/coordinates';

export const favoritesMangerPath = '/user/settings/favorites';

export const favoriteAddPath = '/user/favorites/create';

export const favoriteAddUrl = (coordinates, product) =>
    `${favoriteAddPath}?lat=${coordinates[0]}&lon=${coordinates[1]}&product=${product}`;

export const getForecastNameFromFavorites = (favorites, coordinates) =>
  favorites.reduce((matchedName, favorite) => {
    if (coordinatesT.match(
      [coordinates[1], coordinates[0]],
      favorite.point) &&
      favorite.product === 'marine_weather') {
      return favorite.name;
    }
    return matchedName;
  }, false);



// WEBPACK FOOTER //
// ./src/utils/favorites.js